import { useEffect, useState } from 'react'
import { getPreference, setPreference } from '@fs/zion-preferences'

export default function useUserPreference(preferenceKey, initialDefaultValue) {
  const [defaultValue] = useState(initialDefaultValue)
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    if (preferenceKey) {
      getPreference(preferenceKey).then((preferenceValue) => {
        setValue(preferenceValue || defaultValue)
      })
    }
  }, [defaultValue, preferenceKey])

  function updatePreferenceValue(newValue) {
    if (newValue === value) {
      return false
    }

    setPreference(preferenceKey, newValue)
    setValue(newValue)
    return true
  }

  return [value, updatePreferenceValue]
}
